export default "__VITE_ASSET__Cwcd1s09__"